export function toFit(
    cb, {
        dismissCondition = () => false,
        triggerCondition = () => true
    }
) {
    if (!cb) {
        throw Error('Invalid required arguments')
    }

    let tick = false

    return function () {
        if (tick) {
            return
        }

        tick = true
        return requestAnimationFrame(() => {
            if (dismissCondition()) {
                tick = false
                return
            }

            if (triggerCondition()) {
                tick = false
                return cb()
            }
        })
    }
}

export const getThumbnailImage = (postHtml) => {
    let url = ""
    let imgRegex = /<img\s[^>]*?src\s*=\s*['\"]([^'\"]*?)['\"][^>]*?>/
    let result = imgRegex.exec(String(postHtml))
    if (result && result.length > 1) {
        url = result[1]
    }
    return url
}
